import React from "react";

export const PriceColumnFormatter = (cellContent, row) =>
(<span>
{row.documents && row.documents.nocCertificate? (
   <p>Available</p>
):(<p>Not Available</p>)}
</span>
);
